'use client';

import { useEffect, useState } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

import { CONTEXT_PANEL_WIDTH } from '@/theme/layoutConstants';

export function useResponsiveLayout() {
  const theme = useTheme();
  const [hasTouchInput, setHasTouchInput] = useState(false);

  // Check for touch capability
  useEffect(() => {
    const checkTouch = () => {
      setHasTouchInput(
        'ontouchstart' in window ||
          navigator.maxTouchPoints > 0 ||
          // @ts-ignore - for older browsers
          navigator.msMaxTouchPoints > 0
      );
    };

    checkTouch();
    // Re-check on resize in case of device rotation
    window.addEventListener('resize', checkTouch);
    return () => window.removeEventListener('resize', checkTouch);
  }, []);

  // Screen size breakpoints
  const isNarrowScreen = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  // Sidebar only shows when centered content (md) and fixed sidebar don't overlap.
  // Content half-width from center: md/2. Sidebar from right edge: width + right offset (16px).
  // Minimum viewport: md + 2 * (CONTEXT_PANEL_WIDTH + 16)
  const sidebarClearance = CONTEXT_PANEL_WIDTH + 16;
  const sidebarMinWidth = theme.breakpoints.values.md + 2 * sidebarClearance;
  const isWideEnoughForSidebar = useMediaQuery(`(min-width: ${sidebarMinWidth}px)`);

  // Layout decisions
  const appBarPosition: 'top' | 'bottom' = isNarrowScreen && hasTouchInput ? 'bottom' : 'top';
  const contextPanelVariant: 'sidebar' | 'toolbar' = isWideEnoughForSidebar ? 'sidebar' : 'toolbar';

  return {
    isNarrowScreen,
    isWideEnoughForSidebar,
    hasTouchInput,
    appBarPosition,
    contextPanelVariant,
  };
}
